import React from 'react';
import { Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Titlefield from './title-field';

const Header = ({
  classes, title, subtitle, front,
}) => (
  <Paper
    elevation={0}
    className={clsx(classes.titleFieldContainer, front ? classes.frontcontainer : null)}
  >
    <div className={classes.titleFieldInnerWrapper}>
      <Titlefield title={title} subtitle={subtitle} />
    </div>
  </Paper>
);

const styles = theme => ({
  frontcontainer: {
    borderBottom: '0.0625rem solid #cccccc',
  },
  titleFieldInnerWrapper: {
    marginLeft: theme.containerMarginBase(),
    padding: '0 0.6rem',
  },
  titleFieldContainer: {
    minWidth: '20rem',
    backgroundColor: theme.palette.secondary.main,
  },
});

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.any.isRequired,
  subtitle: PropTypes.any.isRequired,
  front: PropTypes.bool,
};

Header.defaultProps = {
  front: false,
};

export default withStyles(styles)(Header);
